<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi01">
<div class="epigraph">
<p class="epigraphText"><em class="italic">Dance in the sunlight,<br/> dance in the moonlight,<br/> dance on through this do-si-do,<br/> this one and magic life</em>.</p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi01.vue?443cedc4